import React, { Fragment } from "react";

import CoinRank from "../components/CoinRank";

const Main = () => {
  return (
    <Fragment>
      <CoinRank />
    </Fragment>
  );
};

export default Main;
